import { httpApi } from '@api/http.api.ts';
import type {
    DashboardAccessItem,
    DashboardAccessItemData,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/___shared___/types.ts';

export interface VesselDashboardAccessItem extends DashboardAccessItem {
    rankReferences: DashboardAccessItemData[];
}

export interface InsertVesselDashboardAccessRequest {
    vesselGroupIds: number[];
    rankReferenceIds: number[];
    isActive: boolean;
}

const getBaseUrl = (tenantAlias: string) => `admin-center/tenants/${tenantAlias}/rbac/vessel-dashboard-access`;

export const getApiVesselDashboardAccess = (tenantAlias: string): Promise<VesselDashboardAccessItem[]> =>
    httpApi.get<VesselDashboardAccessItem[]>(getBaseUrl(tenantAlias)).then(({ data }) => data);

export const createApiVesselDashboardAccess = (
    tenantAlias: string,
    payload: InsertVesselDashboardAccessRequest,
): Promise<VesselDashboardAccessItem> =>
    httpApi.post<VesselDashboardAccessItem>(getBaseUrl(tenantAlias), payload).then(({ data }) => data);

export const updateApiVesselDashboardAccess = (
    tenantAlias: string,
    accessId: number,
    payload: InsertVesselDashboardAccessRequest,
): Promise<VesselDashboardAccessItem> =>
    httpApi.put<VesselDashboardAccessItem>(`${getBaseUrl(tenantAlias)}/${accessId}`, payload).then(({ data }) => data);

export const deleteApiVesselDashboardAccess = (tenantAlias: string, accessId: number): Promise<any> =>
    httpApi.delete<any>(`${getBaseUrl(tenantAlias)}/${accessId}`).then(({ data }) => data);
